/* src/app/dialog-confirm/dialog-confirm.component.scss */
.dialog {
  color: black;
  height: auto;
  width: 400px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
}
.dialog .modal-body {
  align-items: center;
  justify-content: center;
  display: flex;
}
/*# sourceMappingURL=dialog-confirm.component.css.map */
